import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';

const allSentinelTeamsQuery = loader('./allSentinelTeams.graphql');

export default function useSentinelTeamsQuery(options) {
  return useQuery(allSentinelTeamsQuery, options);
}
